export const CAREER_PROSPECTS_2_CONSTANTS = {
  CAREER_PROSPECTS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Section heading",
      value: "Beyond a Certificate – Built for Career Impact",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Main headline (left column)",
      required: false,
      defaultValue: "Beyond a Certificate – Built for Career Impact",
      rows: 3,
    },
    {
      fieldName: "title_text_color",
      label: "Heading color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_title",
      label: "Supporting paragraph",
      value:
        "Earn recognised credentials and academic recognition.",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Primary paragraph under the heading",
      required: false,
      defaultValue:
        "Earn recognised credentials and academic recognition.",
      rows: 3,
    },
    {
      fieldName: "sub_title_text_color",
      label: "Supporting paragraph color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "note_text",
      label: "Note (below paragraph)",
      value:
        "Top 10 percentile performers in each cohort receive a Certificate with Distinction, recognised on the credential itself.",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Optional emphasis line",
      required: false,
      defaultValue:
        "Top 10 percentile performers in each cohort receive a Certificate with Distinction, recognised on the credential itself.",
      rows: 4,
    },
    {
      fieldName: "note_text_color",
      label: "Note color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "note_italic",
      label: "Render note in italic",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Italic on / off",
      defaultValue: true,
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_text",
      label: "CTA button text (leave empty to hide)",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Apply Now",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_background_color",
      label: "CTA background color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "cta_url",
      label: "CTA destination URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon",
      label: "CTA icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon shown next to button text",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_icon_alt",
      label: "CTA icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for the icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "certificate_image",
      label: "Certificate image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload certificate preview (PNG / JPG / WebP)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "certificate_image_alt",
      label: "Certificate image alt text",
      value: "Certificate",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Certificate",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable / disable section",
      defaultValue: true,
    },
  ],
};
